import { render, staticRenderFns } from "./AppSettings.vue?vue&type=template&id=19d6a95c&scoped=true&"
import script from "./AppSettings.vue?vue&type=script&lang=ts&"
export * from "./AppSettings.vue?vue&type=script&lang=ts&"
import style0 from "./AppSettings.vue?vue&type=style&index=0&id=19d6a95c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d6a95c",
  null
  
)

export default component.exports